import { useWebSiteStore } from '@/stores/web-site.store'
import BaseApi from './base.api'

const SSE_BLOCK_SEPARATOR = '\n\n'
const SSE_DATA_PREFIX = 'data: '
const HTTP_UNAUTHORIZED = 401
const HTTP_NO_CONTENT = 204

export class ChatStreamError extends Error {
  constructor(status) {
    super(`Chat stream failed with status ${status}`)
    this.status = status
  }
}

class ChatApi extends BaseApi {
  streamUrl = 'stream/'
  conversationsUrl = 'conversations/'
  messagesUrl = 'messages/'

  fetchStream = (url, init) => fetch(this.getAbsoluteUrl(`${this.url}${url}`), {
    ...init,
    credentials: 'include',
    headers: { ...this.getClientInstance().defaults.headers.common, ...init.headers },
  })

  openStreamAsync = async(url, init) => {
    let response = await this.fetchStream(url, init)
    if (response.status === HTTP_UNAUTHORIZED) {
      await useWebSiteStore().refreshTokenAsync({ _isRetrying: true })
      response = await this.fetchStream(url, init)
    }
    if (!response.ok) throw new ChatStreamError(response.status)
    return response
  }

  postStreamAsync = (body, signal) => this.openStreamAsync(this.streamUrl, {
    method: 'POST',
    signal,
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  })

  getMessageFileAsync = async(id) => (await this.getAsync(`${this.messagesUrl}files/${id}/`, undefined, { responseType: 'blob' })).data

  getRunningStreamAsync = async(conversationId, signal) => {
    const response = await this.openStreamAsync(`${this.streamUrl}${conversationId}/`, { signal })
    return response.status === HTTP_NO_CONTENT ? null : response
  }

  readEventsAsync = async(response, onEvent) => {
    const reader = response.body.pipeThrough(new TextDecoderStream()).getReader()
    let buffer = ''
    for (;;) {
      const { value, done } = await reader.read()
      if (done) return
      buffer += value
      const blocks = buffer.split(SSE_BLOCK_SEPARATOR)
      buffer = blocks.pop()
      blocks
        .filter(block => block.startsWith(SSE_DATA_PREFIX))
        .forEach(block => onEvent(JSON.parse(block.slice(SSE_DATA_PREFIX.length))))
    }
  }
}

export const chatApi = new ChatApi('ai/')
